const Loader = () => {
  return (
    <div>
      <div className="relative w-20 h-20">
        <div className="absolute inset-0 border-4 border-white border-t-primary rounded-full animate-spin p-2"></div>
        <img
          src="/lotus.png"
          width={40}
          height={40}
          className="absolute   text-2xl top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 "
        />
      </div>
    </div>
  );
};

export default Loader;
